import { CoreInput } from '@/components/Form/InputAntForm';
import { CoreSwitch } from '@/components/Form/Switch';
import { RolesEntity } from '@/domain/entities/roles';
import { Button, Tabs, Typography } from 'antd';
import React from 'react';
import useViewModel from '../../viewmodels/form';
import { RolesCollapse } from './RolesCollapse';
import { FormProvider } from 'react-hook-form';
import { get } from 'lodash';
import { PermissionEntity } from '@/domain/entities/permission';
import useWatchPermission from '../../hooks/useWatchPermission';

interface Props {
  detailRole: RolesEntity;
  openForm: boolean;
  showId: string | null;
  listPermission: PermissionEntity[];
}

type RolePermissions = NonNullable<RolesEntity['permissions']>;

export interface RolesContextValue {
  selectedPermissions: RolePermissions | string[] | undefined;
  listItemChecked: RolePermissions | undefined;
  setListItemChecked: React.Dispatch<React.SetStateAction<RolePermissions | undefined>>;
  data?: Record<string, unknown>;
  nameApp?: string;
}

interface RolesProviderProps extends RolesContextValue {
  children?: React.ReactNode;
}

export const RolesContext = React.createContext<RolesContextValue>({} as RolesContextValue);

export const RolesProvider = ({ children, ...value }: RolesProviderProps) => {
  return <RolesContext.Provider value={value}>{children}</RolesContext.Provider>;
};

export const RolesForm = (props: Props) => {
  const { detailRole, openForm, showId, listPermission } = props;
  const { methodForm, onSubmit, defaultValue, isDuplicate } = useViewModel(props);
  const {
    watch,
    control,
    setValue,
    reset,
    formState: { isSubmitting },
  } = methodForm;

  const watchPermissions = watch().permissions;
  const { selectedPermissions: permissionState } = useWatchPermission(
    watchPermissions,
    detailRole,
    showId,
    defaultValue,
    reset,
    openForm,
    isDuplicate,
  );

  return (
    <RolesProvider
      selectedPermissions={permissionState.selectedPermissions}
      listItemChecked={permissionState.listItemChecked}
      setListItemChecked={permissionState.setListItemChecked}
    >
      <FormProvider {...methodForm}>
        <form onSubmit={onSubmit}>
          <div className='w-full flex flex-wrap justify-between'>
            <div className='text-left'>
              <Typography.Text className='w-full'>Role name (*)</Typography.Text>
              <CoreInput control={control} name='name' className='w-full mb-10' />
            </div>

            <div className='text-left ml-6'>
              <Typography.Text className='w-full'>Status</Typography.Text>
              <CoreSwitch control={control} name='isActive' className='my-auto' />
            </div>
            <Typography.Text className='w-full'>Description (*)</Typography.Text>
            <CoreInput control={control} name='description' className='w-full mb-10' />
          </div>
          <div className='py-lg-8 '>
            <Tabs
              defaultActiveKey='1'
              items={listPermission.map((item) => {
                const id = get(item, 'id');
                return {
                  label: get(item, 'app'),
                  key: id,
                  children: (
                    <RolesCollapse
                      permission={get(item, 'permissions')}
                      name={get(item, 'app')}
                      setValue={setValue}
                    />
                  ),
                };
              })}
            />
          </div>

          <div className='text-right'>
            <Button htmlType='submit' type='primary' loading={isSubmitting}>
              Save
            </Button>
          </div>
        </form>
      </FormProvider>
    </RolesProvider>
  );
};
